// extracted by mini-css-extract-plugin
export default {"auth":"auth_auth__OYJYG","auth-loader":"auth_auth-loader__GiUIn"};